// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"memberPrivacy_buttonContainer__2En7E","heading":"memberPrivacy_heading__3Pep1","inputContainer":"memberPrivacy_inputContainer__2AK9p"};